export default {
  watchTowerTitle: 'Watch Tower',
  watchTowerBody: 'Register external companies. Schedule monitoring agents. Inspect runs in tables.',
  openWatchTower: 'Open Watch Tower',
  marketingOpsTitle: 'Marketing Ops',
  marketingOpsBody: 'Read incidents, risks, and impacts. Find client opportunities.',
  openMarketingOps: 'Open Marketing Ops',
  searchCompanies: 'Search companies',
  country: 'Country',
  industry: 'Industry',
  agentCoverage: 'Agent coverage',
  allCountries: 'All countries',
  allIndustries: 'All industries',
  allAgents: 'All agents',
  statusVisible: 'Not archived',
  statusAll: 'All statuses',
  import: 'Import',
  downloadTemplate: 'Download template',
  newCompany: 'New company',
  companiesTab: 'Companies',
  schedulerTab: 'Scheduler',
  summaryCompanies: 'Companies',
  summaryWithAgents: 'With agents',
  summaryWithoutAgents: 'Without agents',
  summaryAwaitingReview: 'Awaiting review',
  openDossier: 'Open dossier',
  scheduleAgents: 'Schedule agents',
  exportCompany: 'Export this company',
  archive: 'Archive',
  unarchive: 'Unarchive',
  emptyCompanies: 'No watch companies match these filters.',
  emptyCta: 'Import a file or describe a company for Send to AI.',
  companyCreated: 'Draft company added.',
  companySaved: 'Company saved.',
  companyArchived: 'Company archived.',
  companyRestored: 'Company restored.',
  exportStarted: 'Download started.',
  products: 'Products',
  buildings: 'Buildings',
  agents: 'Agents',
  lastRun: 'Last run',
  openFindings: 'Open findings',
  status: 'Status',
  identifiers: 'Identifiers',
  actions: 'Actions',
  identity: 'Identity',
  org: 'Org',
  associations: 'Associations',
  financials: 'Financials',
  coverage: 'Coverage',
  knownList: 'Known list',
  findings: 'Findings',
  save: 'Save',
  name: 'Name',
  code: 'Code',
  uid: 'UID',
  aliases: 'Aliases',
  aliasesHint: 'Comma-separated names',
  website: 'Website',
  notes: 'Notes',
  naceSection: 'NACE section',
  naceCode: 'NACE code',
  addressCountry: 'Country',
  addressCity: 'City',
  addressState: 'State',
  addressStreet: 'Street',
  addressPostCode: 'Post code',
  none: '—',
  comingSoon: 'This screen lands in the next mock slice.',
  importTitle: 'Import',
  importDrop: 'Drop a JSON file here, or pick one from disk.',
  importJsonOnly: 'Excel and CSV wait for a later mock slice.',
  importPick: 'Choose JSON file',
  importConfirm: 'Confirm import',
  importCommitted: 'Watch companies imported.',
  importClean: 'No errors. Warnings do not block commit.',
  importEmptyReport: 'Pick a JSON file to see the validation report.',
  importIssueCounts: '{{errors}} errors, {{warnings}} warnings.',
  importPath: 'Path',
  importRow: 'Row',
  importField: 'Field',
  importMessage: 'Message',
  schedulesTitle: 'Schedules',
  runsTitle: 'Runs',
  knownBuyers: 'Known buyers (this company is the supplier)',
  knownSuppliers: 'Known suppliers (this company is the buyer)',
  sourceFindings: 'Findings for this company',
  investigationConclusions: 'Investigation conclusions',
  watchTowerKind: 'Kind',
  watchTowerKind_potential_competitor: 'Potential competitor',
  findingType_investigation_conclusion: 'Investigation',
  affectedFindings: 'Findings where this company is potentially affected',
  eventKind: 'Event',
  eventKind_competitor: 'Competitor',
  eventKind_person_joined: 'Person joined',
  eventKind_person_left: 'Person left',
  eventKind_person_role: 'Person role',
  eventKind_merger: 'Merger',
  eventKind_acquisition: 'Acquisition',
  eventKind_spin_off: 'Spin-off',
  eventKind_other: 'Other',
  occurredOn: 'Occurred on',
  person: 'Person',
  relatedCompany: 'Related company',
  period: 'Period',
  revenue: 'Revenue',
  ebitda: 'EBITDA',
  liquidity: 'Liquidity',
  marketValuation: 'Market valuation',
  schedule: 'Schedule',
  target: 'Target',
  severity: 'Severity',
  title: 'Title',
  noRows: 'No rows.',
  validationReport: 'Validation report',
  createSchedule: 'Create schedule',
  createScheduleNext: 'Next',
  createScheduleBack: 'Back',
  createScheduleStepType: 'Agent type',
  createScheduleStepTemplates: 'Templates',
  createScheduleStepWhen: 'When',
  createScheduleStepCompanies: 'Companies',
  createSchedulePickType: 'Select one agent type.',
  createSchedulePickTemplates: 'Select one or more templates.',
  createSchedulePickWhen: 'Set the run time.',
  createSchedulePickCompanies: 'Select one or more companies.',
  createScheduleSearchCompanies: 'Search companies',
  createScheduleOnlyWithout: 'Only companies without this type and template',
  createScheduleDuplicates: '{{count}} selected companies already have this agent type and template.',
  createScheduleDuplicateWarn: '{{name}} already has {{template}} for this agent type.',
  saveSchedule: 'Save schedule',
  allSchedules: 'All schedules',
  scheduleSaved: 'Schedule saved.',
  schedulePaused: 'Schedule paused.',
  scheduleResumed: 'Schedule resumed.',
  runNow: 'Run now',
  runNowDone: 'Mock run queued.',
  selectCompanies: 'Watch companies',
  selectAgentType: 'Agent type',
  selectTemplate: 'Template',
  noEnabledTemplate: 'No enabled template of this type. Open Templates in Agents Management.',
  targetGrain: 'Target grain',
  extraTargetKinds: 'Extra target kinds',
  defaultGrain: 'default',
  hourOfDay: 'Hour of day',
  timezone: 'Timezone',
  frequency: 'Frequency',
  frequency_daily: 'Daily',
  frequency_weekly: 'Weekly',
  frequency_monthly: 'Monthly',
  paused: 'Paused',
  pause: 'Pause',
  resume: 'Resume',
  companyColumn: 'Company',
  template: 'Template',
  nextRun: 'Next run',
  targetsCount: 'Targets',
  kindCompany: 'Company',
  kindProduct: 'Products',
  kindBuilding: 'Buildings',
  kindOrgNode: 'Org nodes',
  emptySchedules: 'No schedules yet.',
  noTargetsForKind: 'No {{kind}} on this company.',
  scheduleError_no_companies: 'Select at least one watch company.',
  scheduleError_no_targets: 'Select at least one target. Save is blocked.',
  scheduleError_no_template: 'No enabled template of this type. Open Templates in Agents Management.',
  scheduleError_all_duplicates: 'These companies already have this agent type and template.',
  scheduleSavedSkipped: 'Created {{created}} schedules. Skipped {{skipped}} that already exist.',
  openRuns: 'Open runs',
  runsCrumb: 'Run levels',
  levelSchedule: 'Schedules',
  levelTick: 'Ticks',
  levelTarget: 'Targets',
  levelFinding: 'Findings',
  tickCount: 'Ticks',
  tickTime: 'Time',
  elevatedCount: 'High / critical',
  cost: 'Cost',
  targetKind: 'Kind',
  duration: 'Duration',
  tokens: 'Tokens',
  findingType: 'Type',
  observedAt: 'Observed at',
  confidence: 'Confidence',
  sourceUrl: 'Source',
  payloadPreview: 'Payload',
  payloadHint: 'Open a finding title to see payloadJson.',
  noPayload: 'This finding has no payloadJson.',
  openSource: 'Open source',
  runFailed: 'This run failed.',
  emptyRuns: 'No schedules match this agent filter.',
  emptyTicks: 'This schedule has no ticks yet. Use Run now on Scheduler.',
  emptyTargets: 'This tick has no target runs.',
  emptyFindings: 'This target run has no findings.',
  runAnalysisTitle: 'Run analysis',
  runAnalysisHint: 'Counts use mock today 2 Sep 2026. The map follows the issue timeline.',
  kpiRuns: 'Agent runs',
  kpiFailedRuns: 'Failed runs',
  kpiRunIssues: 'Run issues',
  emptyRunAnalysis: 'No run issues in this window.',
  timelineTitle: 'Issue timeline',
  timelineHint: 'Left is the oldest day. Right is today. Red bars mark the found day.',
  timelineRange: '{{start}} to {{end}}',
  timelineToday: 'Today',
  timelineStart: 'Oldest day in the selected range',
  timelineEnd: 'Newest day in the selected range',
  timelineMark: '{{count}} issues found on {{day}}',
  emptyTimeline: 'No days in this span.',
  issueTrendTitle: 'Issue trend',
  issueTrendHint: 'Counts follow the issue timeline. Group by day, week, or month.',
  issueTrendGrain: 'Group by',
  issueTrendGrainDay: 'Day',
  issueTrendGrainWeek: 'Week',
  issueTrendGrainMonth: 'Month',
  emptyIssueTrend: 'No days in this timeline range.',
  issueTrendCount: 'Issue count',
  issueTrendTime: 'Time',
  issueMapTitle: 'Issue map',
  issueMapHint: 'Markers follow the issue timeline. A click on a marker filters by country.',
  issueMapLocations: 'Impacted locations',
  issueMapFilter: 'Filter locations',
  issueMapFilterPlaceholder: 'City, country, company, or severity',
  issueMapEmpty: 'No issues in this timeline range.',
  issueMapZoomIn: 'Zoom in',
  issueMapZoomOut: 'Zoom out',
  issueMapReset: 'Reset zoom',
  issueMapResetShort: 'Reset',
  issueMapHeight: 'Map height {{scale}}×',
  issueMapHeightShort: '{{scale}}×',
  issueMapLegendSevere: 'High and critical',
  issueMapLegendMedium: 'Medium',
  issueMapLegendLow: 'Low',
  issueMapLang: 'Map labels',
  issueMapLangEn: 'English',
  issueMapLangDe: 'Deutsch',
  issueMapLangFr: 'Français',
  issueMapLocation: '{{city}}, {{country}}',
  issueMapMarker: '{{count}} issues in {{city}}, {{country}}',
  justNow: 'Just now',
  minutesAgo: '{{count}} minutes ago',
  hoursAgo: '{{count}} hours ago',
  daysAgo: '{{count}} days ago',
  issueTimeTitle: 'Heat (severity × agent)',
  runIssuesTitle: 'Run issues',
  emptyRunIssues: 'No run issues match these filters.',
  runStatus: 'Run status',
  allRunStatuses: 'All run statuses',
  pulseTitle: 'Pulse',
  pulseWindow: 'Pulse window',
  pulseMockToday: 'Counts use mock today 2 Sep 2026.',
  window7: 'Last 7 days',
  window30: 'Last 30 days',
  window90: 'Last 90 days',
  kpiElevated: 'Elevated findings',
  kpiCompanies: 'Watch companies with alerts',
  kpiOpportunities: 'New opportunities',
  kpiAgentMix: 'Agent mix',
  heatTitle: 'Heat (country × agent)',
  emptyPulse: 'No elevated findings in this window.',
  feedTitle: 'Incident feed',
  emptyFeed: 'No incidents match these filters.',
  allSeverities: 'All severities',
  hasAffected: 'Affected companies',
  hasAffectedAny: 'Any affected status',
  hasAffectedYes: 'Has affected company',
  hasAffectedNo: 'No affected company',
  openStory: 'Open story',
  openInWatchTower: 'Open in Watch Tower',
  riskTitle: 'Risk board',
  groupBy: 'Group by',
  groupCompany: 'Watch company',
  groupIndustry: 'Industry',
  groupCountry: 'Country',
  groupAgent: 'Agent',
  opportunityTitle: 'Opportunity board',
  emptyOpportunity: 'No affected-company links yet.',
  issue: 'Issue',
  sourceCompany: 'Source watch company',
  affectedCompany: 'Affected watch company',
  relation: 'Relation',
  emailCol: 'E-mail',
  emailNotSent: 'Not sent',
  flaggedBy: 'Flagged by',
  talkingPoint: 'Talking point',
  runDigest: 'Run daily digest',
  digestEmpty: 'No new affected links wait for a daily summary.',
  digestSentToast: 'Daily summary appended to the mock outbox.',
  statusSaved: 'Affected-link status saved.',
  sourceSnapshot: 'Source watch company',
  agentFound: 'What the agent found',
  sources: 'Sources',
  affectedCompanies: 'Potentially affected watch companies',
  emptyAffected: 'No affected watch companies on this finding.',
  identification: 'Identify affected companies',
  pathSoon: 'Path A, Path B, and Issue chat land in the next mock slice.',
  runDiscovery: 'Run Affected Company Discovery',
  addKnownList: 'Add supplier to known list',
  openIssueChat: 'Issue chat',
  digestLog: 'Daily marketing digest',
  emptyDigest: 'No digest rows include this finding.',
  digestSent: 'Sent at',
  digestTo: 'To',
  digestSubject: 'Subject',
  pathHint: 'Path B flags this incident only. Issue chat uses Nest. Affected Company Discovery is not on Nest yet.',
  discoveryNotLive: 'Affected Company Discovery is not on Nest yet.',
  knownHint: 'Pick or create a buyer. This source is the supplier. The write flags this incident only.',
  knownBuyer: 'Buyer watch company',
  knownCreateBuyer: 'Create a new buyer',
  knownNoProduct: 'No product',
  knownConfirm: '{{source}} is the supplier on this buyer known list.',
  knownConfirmRequired: 'Confirm that this source is the supplier on the buyer known list.',
  knownSave: 'Save known list',
  knownSaved: 'Known list saved. This incident is flagged. The link waits for the daily digest.',
  knownAlreadyFlagged: 'This buyer is already flagged on this incident.',
  knownError_same_company: 'The buyer cannot be the source company.',
  knownError_missing_buyer: 'Select a buyer watch company.',
  knownError_missing_source: 'Source watch company is missing.',
  knownError_missing_finding: 'Finding is missing.',
  knownError_invalid_country: 'Country must be ISO 3166-1 alpha-2.',
  knownError_missing_name: 'Buyer name is required.',
  knownError_missing_uid: 'Buyer UID is required.',
  chatHint:
    'Type a message in the assistant. Enter sends. Shift+Enter starts a new line. Import is a tool on this chat.',
  chatBound: 'This chat is pinned to the assistant transcript.',
  chatBindFailed: 'The assistant did not return a chat id. Send again after CORS exposes X-Ai-Chat-Id.',
  chatEmpty: 'No turns yet.',
  chatDraft: 'Message',
  chatEmptyTurn: 'Write a message first.',
  chatEnterHint: 'Enter sends. Shift+Enter starts a new line.',
  chatChips: 'Context chips',
  chipFinding: 'Finding',
  chipSource: 'Source company',
  chipProducts: 'Products',
  chipBuildings: 'Buildings',
  chipKnownBuyers: 'Known buyers',
  chipOtherFindings: 'Other elevated findings',
  chipPathASeed: 'Path A seed turns',
  chatImportedTurn: 'This turn includes import JSON.',
  sendToAi: 'Send',
  sendToAiInvalid: 'The canned reply is not valid import JSON. The app did not import.',
  sendToAiImported: 'Imported {{count}} watch companies and flagged this incident.',
  createChatHint:
    'Talk to the assistant about the firm. After two turns the mock list is ready for Create company.',
  createChatHintLive:
    'Talk about one firm or a set (country, sector, product). '
    + 'Public lookup can fill up to five firms. Create company inserts new firms only.',
  createCompany: 'Create company',
  createChatCreated: 'Created {{count}} watch companies.',
  createChatInvalid: 'The seed is not complete. The chat lists the missing facts.',
  createChatAllSkipped: 'Every seed already exists. Create company skipped them.',
  createChatSendBlocked: 'This chat is already committed.',
  createChatPendingTitle: 'Companies to create',
  createChatPendingEmpty: 'Describe a firm in the chat. The list fills after the second turn.',
  createChatPendingEmptyLive: 'Describe a firm or a set in the chat. Public lookup fills this list.',
  createChatPendingNew: 'New',
  createChatPendingSkip: 'Already exists ({{uid}}). Skip.',
  createChatReadyHint: 'Five firms are on the list. Click Create company.',
  talkToAi: 'Talk to AI',
  dossierChatHint:
    'Talk to the assistant about this dossier. Nest tools read and write company facts.',
  dossierChatContext: 'Context for this screen: {{company}}. Findings: {{findings}}.',
  dossierChatFailed: 'The canned dossier reply failed.',
  dossierChatReplied: 'Canned dossier reply saved.',
  dossierSearch_products: 'Search products',
  dossierSearch_buildings: 'Search buildings',
  dossierSearch_associations: 'Search associations',
  dossierSearch_financials: 'Search financials',
  dossierSearch_known_list: 'Search known list',
  dossierRerunInvestigation: 'Re-run Company Investigation',
  dossierSearchOn: 'Active search: {{tab}}.',
  dossierSearchReplied: 'Canned search reply saved.',
  dossierSearchPendingTitle: 'Search hits',
  dossierSearchPendingEmpty: 'No new rows yet. Pick a search or send another message.',
  dossierImport: 'Import search hits',
  dossierImported: 'Imported {{count}} rows into the dossier.',
  dossierImportError_missing_chat: 'The chat is missing.',
  dossierImportError_missing_company: 'The company is missing.',
  dossierImportError_no_hits: 'The last reply has no new rows.',
  dossierImportError_already_imported: 'Those rows are already in the dossier.',
  aiStatus: 'AI status',
  aiStatus_idle: 'Idle',
  aiStatus_review_ongoing: 'Review Ongoing',
  aiStatus_awaiting_human_review: 'Awaiting Human Review',
  aiStatus_finalized: 'Finalized',
  aiStatus_in_error: 'In error',
  aiStatus_human_rejected: 'Human Rejected',
  aiStatus_human_accepted: 'Human Accepted',
  investigationOngoing: 'Company Investigation is running.',
  investigationError: 'Company Investigation failed.',
  investigationReviewHint:
    'Green is the suggested text. Red strike is the current text. Approve applies. Cancel discards.',
  investigationApprove: 'Approve suggestions',
  investigationCancel: 'Cancel request',
  investigationRetry: 'Retry investigation',
  investigationAccepted: 'Suggestions applied. AI status is Human Accepted.',
  investigationRejected: 'Suggestions discarded. AI status is Human Rejected.',
  investigationRetryQueued: 'Company Investigation queued again.',
  topicsTab: 'Topics',
  topicsTitle: 'Topics',
  newTopic: 'New topic',
  emptyTopics: 'No topics yet.',
  emptyTopicsCta: 'Create a topic. The agent watches a theme, not a company.',
  openTopic: 'Open topic',
  matchKinds: 'Match kinds',
  linkedCompanies: 'Linked companies',
  topicStatus: 'Status',
  topicPaused: 'Topic paused.',
  topicResumed: 'Topic resumed.',
  topicArchived: 'Topic archived.',
  topicRestored: 'Topic restored.',
  topicCreated: 'Topic saved.',
  topicRunDone: 'Topic run complete. Matching companies are linked.',
  topicRunBlocked: 'This topic is paused or archived. Resume it first.',
  namedMisses: 'Named misses',
  namedMissImported: 'Named miss imported. Company Investigation is queued.',
  registerNamedMiss: 'Import and investigate',
  namedMissImportedAlready: 'Imported',
  trainingBrief: 'Training brief',
  matchRules: 'Match rules (optional)',
  matchRulesHint: 'Comma-separated values. Empty fields do not add a filter.',
  matchCountries: 'Countries (ISO)',
  matchCities: 'Cities',
  matchNace: 'NACE sections',
  matchHs: 'HS prefixes',
  matchProductNeedles: 'Product needles',
  matchAnyKind: 'A hit needs any selected kind, not every kind',
  createTopic: 'New topic',
  createTopicStepTitle: 'Title',
  createTopicStepType: 'Type',
  createTopicStepBrief: 'Brief',
  createTopicStepMatch: 'Match',
  createTopicStepWhen: 'When',
  createTopicPickTitle: 'Enter a title for this theme.',
  createTopicPickBrief: 'Write the training brief for this theme.',
  createTopicPickMatch: 'Select one or more dossier fields. The matcher reads those fields after a finding.',
  createTopicPickWhen: 'Set the run time, begin date, and optional end date.',
  saveTopic: 'Save topic',
  topicError_no_title: 'Enter a title.',
  topicError_no_template: 'Select one enabled template.',
  topicError_no_brief: 'Enter a training brief.',
  topicError_no_match_kinds: 'Select at least one match kind.',
  topicError_no_start_date: 'Set a begin date.',
  topicError_end_before_start: 'End date must be on or after the begin date.',
  beginDate: 'Begin date',
  endDate: 'End date',
  noEndDate: 'No end date',
  sourceKind: 'Source',
  sourceKind_company: 'Company',
  sourceKind_topic: 'Topic',
  topicBlock: 'Topic',
  noSourceCompany: 'This finding has no source company. It comes from a topic.',
  matchKind_identity_geo: 'Identity / geo',
  matchKind_industry: 'Industry',
  matchKind_product: 'Product',
  matchKind_building: 'Building',
  matchKind_org: 'Org',
  matchKind_association: 'Association',
  matchKind_financials: 'Financials',
  kindTopic: 'Topic',
  topicBriefChatHint:
    'The stored training brief is below. Brief chat is not on Nest yet.',
  topicBriefPreview: 'Compiled training brief',
  topicBriefReplied: 'Training brief updated from the chat.',
  liveRequestFailed: 'The Watch Tower request failed.',
  runNowNotLive: 'Run now is not on Nest yet. The scheduler tick starts the run.',
  investigationRunsTitle: 'Investigation runs',
  investigationRunsEmpty: 'No unscheduled investigation runs.',
  investigationRunsError: 'The investigation run list failed.',
  investigationRunsLoading: 'The investigation run list is not ready.',
  investigationRunLabel: 'Run {{id}}',
  investigationRunStatus: 'Status',
  investigationRunModel: 'Model',
  investigationRunTime: 'Time',
  investigationRunCost: 'Cost',
  investigationRunOutput: 'Output',
  investigationContinue: 'Continue',
  investigationContinueQueued: 'Company Investigation continues on the same run.',
  investigationContinueReason_not_latest: 'Continue is only for the latest run.',
  investigationContinueReason_not_failed: 'Continue is only for a failed run.',
  investigationContinueReason_run_busy: 'An unscheduled run is pending or in progress.',
  investigationStepsEmpty: 'This run has no stored steps.',
  investigationStepsError: 'The step list failed.',
  investigationStepsLoading: 'The step list is not ready.',
  investigationStepSearchCount: 'Searches',
  investigationStepNoResponse: 'This step has no stored response.',
  investigationStepCopy: 'Copy to dossier chat',
  investigationStepConclusionsNote:
    'Conclusion rows exist only after merge_patch succeeds. This run still shows the stored step responses.',
  investigationStepAttachedInline:
    'Run {{runId}}, step {{stepIndex}} ({{promptRole}}) is attached for company {{companyId}}. '
    + 'The next message sends the stored response. It is not sent yet.',
  investigationStepAttachedReference:
    'This step is {{count}} characters. The chat context limit is 4000 characters. '
    + 'The next message names the run, the step, the role, and the company. '
    + 'It does not send a shortened response. The server must load the stored response.',
  investigationStepAttachedOverCap:
    'This step is {{count}} characters. The limit for one stored step is 100000 characters. It is not attached.',
  investigationStepRemove: 'Remove step',
  investigationStepFullResponse: 'Full response',
  investigationStepTableCap: 'The table lists the first {{shown}} of {{total}} rows. The full response is below.',
  investigationStepColumnCap: 'The table keeps the first {{count}} columns. The full response is below.',
};
